import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CheckboxField,
} from '@contentful/forma-36-react-components';

import './TranslationResultTable.css';

import {
  FIELD_TYPE_SYMBOL,
  SYMBOL_MAX_CHARACTER_COUNT,
} from '../../utils/constants';

export const TranslationResultTable = ({
  languages,
  fieldType,
  selectedLocales = {},
  onLocaleChange,
  selectionIdPrefix = '',
} : {
  languages: any,
  fieldType: string,
  selectedLocales?: Record<string, boolean>,
  onLocaleChange?: (locale: string) => void,
  selectionIdPrefix?: string,
}) => {
  const languagesArray = Object.keys(languages || {});
  const isRichText = fieldType === 'RichText';
  return (
    <>
      <Table className="table-wrapper">
        <TableHead>
          <TableRow>
            <TableCell>Language</TableCell>
            <TableCell>Author</TableCell>
            <TableCell>Text</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {languagesArray.map((lang, idx) => {
            const shouldShowAsError =
              fieldType === FIELD_TYPE_SYMBOL &&
              languages[lang] &&
              languages[lang].length > SYMBOL_MAX_CHARACTER_COUNT;
            const authorable = Boolean(languages[lang]) && !['en', 'en-us'].includes(lang.toLowerCase());

            return (
              <TableRow key={idx} selected={shouldShowAsError}>
                <TableCell className={shouldShowAsError ? 'error' : ''}>{lang}</TableCell>
                <TableCell>
                  <CheckboxField
                    aria-label={`Author ${lang}`}
                    checked={Boolean(selectedLocales[lang])}
                    disabled={!authorable}
                    id={`author-${selectionIdPrefix}-${lang}`}
                    labelText=''
                    name={`author-${selectionIdPrefix}-${lang}`}
                    onChange={() => onLocaleChange?.(lang)}
                  />
                </TableCell>
                <TableCell>
                  {shouldShowAsError ? (
                    <span className="error">
                      Oops! Your text is a bit too long—please keep it under 256 characters.
                      <br />
                      If you need help or have special requirements, kindly contact the localization team for support.
                      <br />
                      <br />
                    </span>
                  ) : ''}
                  {(languages[lang] && isRichText && JSON.stringify(languages[lang])) || languages[lang] || 'null'}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </>
  )
};
